export const PRODUCT_REVIEWS_ENDPOINT = `https://api.reviews.io/product/review?store=gourmetbasket-com-au&sort=date_desc&lang=en&enable_avatars=true&include_subrating_breakdown=1&per_page=5&apikey=de96e528efedf497c005c9932eab62ae&sku=`;
